import { BaseOrganizationEndpoints } from './base';
import {
  PostHours,
  PostOperationalHours,
  ResGetAllHours
} from '../types/api-types';
import { format } from 'date-fns';
import { HourQueryParams, WeekDayNames } from '../entities/hours';
import { IResource } from '../entities/resource';

export class HoursClient extends BaseOrganizationEndpoints {
  async all(officeId: string) {
    return this.requestWithStatus<ResGetAllHours>(
      'GET',
      `/offices/${encodeURIComponent(officeId)}/hours`
    );
  }

  async rules(officeId: string, resourceId?: IResource['id']) {
    return this.requestWithStatus<ResGetAllHours>(
      'GET',
      `/offices/${encodeURIComponent(officeId)}/hours?type=rule${resourceId ? `&resource=${encodeURIComponent(resourceId)}` : ''}`
    );
  }

  async weekdays(officeId: string) {
    return this.requestWithStatus<ResGetAllHours>(
      'GET',
      `/offices/${encodeURIComponent(officeId)}/hours?type=weekday`
    );
  }

  async holidays(officeId: string) {
    return this.requestWithStatus<ResGetAllHours>(
      'GET',
      `/offices/${encodeURIComponent(officeId)}/hours?type=holiday`
    );
  }

  async create(officeId: string, body: PostHours, params: HourQueryParams) {
    const url = this.addGenericParamsToUrl(
      `/offices/${encodeURIComponent(officeId)}/hours`,
      params
    );
    return this.requestWithStatus<unknown>('POST', url, body);
  }
  async createForResource(
    resourceId: IResource['id'],
    body: PostHours,
    params: HourQueryParams
  ) {
    const url = this.addGenericParamsToUrl(
      `/resources/${encodeURIComponent(resourceId)}/hours`,
      params
    );
    return this.requestWithStatus<unknown>('POST', url, body);
  }

  async updateWeekdays(officeId: string, body: PostOperationalHours) {
    const data: any[] = [];
    Object.keys(body).forEach((day) => {
      const dayName = day as WeekDayNames;
      data.push({
        ...body[dayName],
        //day: dayName,
        start_time: format(body[dayName].start_time, 'HH:mm:ss'),
        end_time: format(body[dayName].end_time, 'HH:mm:ss')
      });
    });
    return this.requestWithStatus<unknown>(
      'PUT',
      `/offices/${encodeURIComponent(officeId)}/operational`,
      {
        days: data
      }
    );
  }

  async delete(officeId: string, hourId: string) {
    return this.requestWithStatus<unknown>(
      'DELETE',
      `/offices/${encodeURIComponent(officeId)}/hours/${encodeURIComponent(hourId.toString())}`
    );
  }
  async put(
    officeId: string,
    hourId: string,
    body: PostHours,
    params: HourQueryParams
  ) {
    const url = this.addGenericParamsToUrl(
      `/offices/${encodeURIComponent(officeId)}/hours/${encodeURIComponent(hourId.toString())}`,
      params
    );
    return this.requestWithStatus<unknown>('PUT', url, body);
  }

  async get(officeId: string, hourId: string) {
    return this.requestWithStatus<unknown>(
      'GET',
      `/offices/${encodeURIComponent(officeId)}/hours/${encodeURIComponent(hourId.toString())}`
    );
  }
}
